import gql from 'graphql-tag';

export default gql`
  query getIntegratedEntityMappings(
    $vtsIntegrationId: UUID!
    $integratedEntityType: IntegratedEntityType
  ) {
    getIntegratedEntityMappings(
      vtsIntegrationId: $vtsIntegrationId
      integratedEntityType: $integratedEntityType
    ) {
      entityMappings {
        vtsEntityId
        cesSei {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        thirdPartyEntityId
        integratedEntityType
      }
    }
  }
`;
